import React, { Component, Children } from 'react';
import PropTypes from 'prop-types';
import { replace } from 'react-router-redux';
import { withTranslation } from 'react-i18next';
import qs from 'qs';
import { flashErrorMessage } from '../../actions/flash';
import { fetchM } from '../../actions/fetchM';
import isNumber from '../../utils/numbers/isNumber';
import { TRANSLATION_FILES } from '../../constants/translation';

class Projects extends Component {
  static propTypes = {
    children: PropTypes.node,
    location: PropTypes.shape({
      pathname: PropTypes.string,
      query: PropTypes.object,
    }),
  }
  static contextTypes = {
    store: PropTypes.object,
  }

  constructor(props) {
    super(props);
    this.state = {
      token: null,
      count: 0,
      limit: 0,
      offset: 0,
      loading: true,
      data: [],
      projectPins: [],
      projectPinsToken: null,
    };
  }
  componentDidMount() {
    const { store } = this.context;
    const { pathname, query } = this.props.location;
    this.fetchProjects(query, true);
    if (!pathname.includes('/new/') && !pathname.includes('/new_old/')) {
      if (!isNumber(query.page) || query.page <= 0) {
        delete query.page;
      }
      store.dispatch(replace(`/projects/?${qs.stringify(query)}`));
    }
  }
  componentWillReceiveProps(nextProps) {
    const { pathname, query } = nextProps.location;
    if (!pathname.includes('/new/') && !pathname.includes('/new_old/')) {
      if (!this.state.loading) {
        const isFirstPage = parseInt(query.page || 1, 10) === 1;
        this.fetchProjects(query, isFirstPage);
      }
    }
  }
  setProjects(data = []) {
    return new Promise((res) => {
      this.setState({
        data: data || [],
      }, () => {
        res(data);
      });
    });
  }
  setProjectPins(data = []) {
    return new Promise((res) => {
      this.setState({
        projectPins: data || [],
      }, () => {
        res(data);
      });
    });
  }
  setComponentState(state = {}) {
    return new Promise((res) => {
      this.setState(state, () => {
        res(state);
      });
    });
  }
  setLoading(loading = false) {
    return new Promise((res) => {
      this.setState({ loading }, () => {
        res(loading);
      });
    });
  }
  async fetchProjects(q, shouldFetchPinned) {
    await this.setLoading(true);
    const { store } = this.context;
    const { t } = this.props;
    const query = Object.assign({}, q);
    query.excludePinned = false;
    if (!query.page || !isNumber(query.page) || query.page <= 0) {
      query.page = 1;
    }
    const queryKeys = Object.keys(query);
    const hasBuFilter = queryKeys.some(key => key.startsWith('projectBusinessUnit'));
    const hasStatusFilter = queryKeys.some(key => key.startsWith('projectStatus'));
    const hasStateFilter = queryKeys.some(key => key.startsWith('projectState'));
    const hasFilter =
      hasBuFilter ||
      hasStatusFilter ||
      hasStateFilter ||
      (query.dateRange && query.dateRange.length > 0) ||
      (query.dateFrom && query.dateFrom.length > 0) ||
      (query.dateTo && query.dateTo.length > 0) ||
      (query.search && query.search.length > 0);
    if (!hasFilter) {
      query.excludePinned = true;
    }

    let res;
    try {
      res = await store.dispatch(fetchM(`/projects/?${qs.stringify(query)}`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (e) {
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: t('An error occurred, please refresh page') }));
      await this.setLoading(false);
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const token = res.headers.get('X-Csrf-Token');
      const count = parseInt(res.headers.get('M-Data-count'), 10);
      const limit = parseInt(res.headers.get('M-Data-limit'), 10);
      const offset = parseInt(res.headers.get('M-Data-offset'), 10);
      const data = await res.json();
      await this.setProjects(data);
      // handle token.. etc
      await this.setComponentState({
        token,
        count,
        limit,
        offset,
      });
      if (shouldFetchPinned) {
        this.fetchPinnedProjects();
      }
    }
    await this.setLoading(false);
  }
  async fetchPinnedProjects() {
    await this.setLoading(true);
    const { store } = this.context;
    const { t } = this.props;
    let res;
    try {
      res = await store.dispatch(fetchM('/project_pins/', {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (e) {
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: t('An error occurred, please refresh page') }));
      await this.setLoading(false);
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const token = res.headers.get('X-Csrf-Token');
      const data = await res.json();
      await this.setProjectPins(data);
      // handle token.. etc
      await this.setComponentState({
        projectPinsToken: token,
      });
    }
    await this.setLoading(false);
  }
  renderChild() {
    return Children.map(this.props.children, child => (
      React.cloneElement(child, {
        token: this.state.token,
        count: this.state.count,
        limit: this.state.limit,
        offset: this.state.offset,
        loading: this.state.loading,
        data: this.state.data,
        projectPins: this.state.projectPins,
        projectPinsToken: this.state.projectPinsToken,
      })
    ));
  }
  render() {
    return (
      <div>
        {this.renderChild()}
      </div>
    );
  }
}

export default withTranslation(TRANSLATION_FILES.translation)(Projects);



// WEBPACK FOOTER //
// ./src/containers/Projects/Projects.jsx